export const PlatformType = {
  IOT: 'IOT',
};
